namespace GeniuzPOS.Purchase {
    export namespace PermissionKeys {
        export const General = "";

        namespace PoSupplier {
            export const Modify = "5Purchase:\u0E1C\u0E39\u0E49\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22:Modify";
            export const View = "5Purchase:\u0E1C\u0E39\u0E49\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22:View";
        }

        namespace datapo {
            export const Modify = "5Purchase:\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E49\u0E32\u0E07\u0E2D\u0E34\u0E07\u0E23\u0E30\u0E1A\u0E1A\u0E0B\u0E37\u0E49\u0E2D:Modify";
            export const View = "5Purchase:\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E49\u0E32\u0E07\u0E2D\u0E34\u0E07\u0E23\u0E30\u0E1A\u0E1A\u0E0B\u0E37\u0E49\u0E2D:View";
        }

        namespace PRCreate {
            export const Modify = "5Purchase:\u0E43\u0E1A\u0E02\u0E2D\u0E0B\u0E37\u0E49\u0E2D(PR):\u0E2A\u0E23\u0E49\u0E32\u0E07:Modify";
            export const View = "5Purchase:\u0E43\u0E1A\u0E02\u0E2D\u0E0B\u0E37\u0E49\u0E2D(PR):\u0E2A\u0E23\u0E49\u0E32\u0E07:View";
        }

        namespace PRApprove {
            export const Modify = "5Purchase:\u0E43\u0E1A\u0E02\u0E2D\u0E0B\u0E37\u0E49\u0E2D(PR):\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:Modify";
            export const View = "5Purchase:\u0E43\u0E1A\u0E02\u0E2D\u0E0B\u0E37\u0E49\u0E2D(PR):\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:View";
        }

        namespace POCreate {
            export const Modify = "5Purchase:\u0E43\u0E1A\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D(PO):\u0E2A\u0E23\u0E49\u0E32\u0E07:Modify";
            export const View = "5Purchase:\u0E43\u0E1A\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D(PO):\u0E2A\u0E23\u0E49\u0E32\u0E07:View";
        }

        namespace POApprove {
            export const Modify = "5Purchase:\u0E43\u0E1A\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D(PO):\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:Modify";
            export const View = "5Purchase:\u0E43\u0E1A\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D(PO):\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:View";
        }

        namespace PICreate {
            export const Modify = "5Purchase:\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32(\u0E41\u0E08\u0E49\u0E07\u0E2B\u0E19\u0E35\u0E49\u0E0B\u0E37\u0E49\u0E2D)(PI):\u0E2A\u0E23\u0E49\u0E32\u0E07:Modify";
            export const View = "5Purchase:\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32(\u0E41\u0E08\u0E49\u0E07\u0E2B\u0E19\u0E35\u0E49\u0E0B\u0E37\u0E49\u0E2D)(PI):\u0E2A\u0E23\u0E49\u0E32\u0E07:View";
        }

        namespace PIApprove {
            export const Modify = "5Purchase:\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32(\u0E41\u0E08\u0E49\u0E07\u0E2B\u0E19\u0E35\u0E49\u0E0B\u0E37\u0E49\u0E2D)(PI):\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:Modify";
            export const View = "5Purchase:\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32(\u0E41\u0E08\u0E49\u0E07\u0E2B\u0E19\u0E35\u0E49\u0E0B\u0E37\u0E49\u0E2D)(PI):\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:View";
        }

        namespace IRCreate {
            export const Modify = "5Purchase:\u0E43\u0E1A\u0E41\u0E08\u0E49\u0E07\u0E2B\u0E19\u0E35\u0E49(IR):\u0E2A\u0E23\u0E49\u0E32\u0E07:Modify";
            export const View = "5Purchase:\u0E43\u0E1A\u0E41\u0E08\u0E49\u0E07\u0E2B\u0E19\u0E35\u0E49(IR):\u0E2A\u0E23\u0E49\u0E32\u0E07:View";
        }

        namespace IRApprove {
            export const Modify = "5Purchase:\u0E43\u0E1A\u0E41\u0E08\u0E49\u0E07\u0E2B\u0E19\u0E35\u0E49(IR):\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:Modify";
            export const View = "5Purchase:\u0E43\u0E1A\u0E41\u0E08\u0E49\u0E07\u0E2B\u0E19\u0E35\u0E49(IR):\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:View";
        }

        namespace CNCreate {
            export const Modify = "5Purchase:\u0E43\u0E1A\u0E2A\u0E48\u0E07\u0E04\u0E37\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32(\u0E43\u0E1A\u0E25\u0E14\u0E2B\u0E19\u0E35\u0E49)(PC):\u0E2A\u0E23\u0E49\u0E32\u0E07:Modify";
            export const View = "5Purchase:\u0E43\u0E1A\u0E2A\u0E48\u0E07\u0E04\u0E37\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32(\u0E43\u0E1A\u0E25\u0E14\u0E2B\u0E19\u0E35\u0E49)(PC):\u0E2A\u0E23\u0E49\u0E32\u0E07:View";
        }

        namespace CNApprove {
            export const Modify = "5Purchase:\u0E43\u0E1A\u0E2A\u0E48\u0E07\u0E04\u0E37\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32(\u0E43\u0E1A\u0E25\u0E14\u0E2B\u0E19\u0E35\u0E49)(PC):\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:Modify";
            export const View = "5Purchase:\u0E43\u0E1A\u0E2A\u0E48\u0E07\u0E04\u0E37\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32(\u0E43\u0E1A\u0E25\u0E14\u0E2B\u0E19\u0E35\u0E49)(PC):\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:View";
        }

        namespace CNRTVCreate {
            export const Modify = "5Purchase:\u0E43\u0E1A\u0E25\u0E14\u0E2B\u0E19\u0E35\u0E49(CNRTV):\u0E2A\u0E23\u0E49\u0E32\u0E07:Modify";
            export const View = "5Purchase:\u0E43\u0E1A\u0E25\u0E14\u0E2B\u0E19\u0E35\u0E49(CNRTV):\u0E2A\u0E23\u0E49\u0E32\u0E07:View";
        }

        namespace CNRTVApprove {
            export const Modify = "5Purchase:\u0E43\u0E1A\u0E25\u0E14\u0E2B\u0E19\u0E35\u0E49(CNRTV):\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:Modify";
            export const View = "5Purchase:\u0E43\u0E1A\u0E25\u0E14\u0E2B\u0E19\u0E35\u0E49(CNRTV):\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34:View";
        }

        namespace po4 {
            export const View = "5Purchase:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E43\u0E1A\u0E02\u0E2D\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E04\u0E07\u0E04\u0E49\u0E32\u0E07:View";
        }

        namespace po1 {
            export const View = "5Purchase:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E43\u0E1A\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E04\u0E07\u0E04\u0E49\u0E32\u0E07:View";
        }

        namespace po5 {
            export const View = "5Purchase:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E07\u0E04\u0E49\u0E32\u0E07:View";
        }

        namespace po6 {
            export const View = "5Purchase:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E43\u0E1A\u0E04\u0E37\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E07\u0E04\u0E49\u0E32\u0E07:View";
        }

        namespace po2 {
            export const View = "5Purchase:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E23\u0E32\u0E22\u0E27\u0E31\u0E19\u0E43\u0E1A\u0E2D\u0E34\u0E19\u0E27\u0E2D\u0E22\u0E27\u0E4C\u0E0B\u0E37\u0E49\u0E2D:View";
        }

        namespace po3 {
            export const View = "5Purchase:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E43\u0E1A\u0E25\u0E14\u0E2B\u0E19\u0E35\u0E49\u0E0B\u0E37\u0E49\u0E2D:View";
        }

        namespace potax {
            export const View = "5Purchase:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E20\u0E32\u0E29\u0E35\u0E0B\u0E37\u0E49\u0E2D:View";
        }
    }
}
